webpackJsonp([162898551421021],{

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-image: url(', ');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-image: url(', ');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 52em;\n  padding-left: 2rem;\n  padding-right: 2rem;\n'], ['\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 52em;\n  padding-left: 2rem;\n  padding-right: 2rem;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  color: white;\n  font-size: 2rem;\n\n  @media (min-width: 52em) {\n    font-size: 3rem;\n  }\n'], ['\n  text-align: center;\n  color: white;\n  font-size: 2rem;\n\n  @media (min-width: 52em) {\n    font-size: 3rem;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  color: white;\n  font-size: 1.5rem;\n\n  @media (min-width: 52em) {\n    font-size: 2rem;\n  }\n'], ['\n  text-align: center;\n  color: white;\n  font-size: 1.5rem;\n\n  @media (min-width: 52em) {\n    font-size: 2rem;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  color: white;\n  text-decoration: none;\n'], ['\n  color: white;\n  text-decoration: none;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _hero = __webpack_require__(103);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Hero = _styledComponents2.default.div(_templateObject, _hero2.default);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Heading = _styledComponents2.default.h1(_templateObject3);
	
	var Text = _styledComponents2.default.div(_templateObject4);
	
	var BackLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject5);
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    Hero,
	    null,
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        Heading,
	        null,
	        'Etsim\xE4\xE4si sivua ei l\xF6ytynyt.'
	      ),
	      _react2.default.createElement(
	        Text,
	        null,
	        _react2.default.createElement(
	          BackLink,
	          { to: '/' },
	          'Palaa takaisin etusivulle \u2192'
	        )
	      )
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-868246032212b4a718b7.js